import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { View, TouchableOpacity, Platform } from 'react-native';
import { Feather } from '@expo/vector-icons';

let Modal;
if (Platform.OS === 'web') {
	Modal = require('./Modal.web').default;
} else {
	Modal = require('react-native-modal').default;
}

import { DialogContext } from '../../../common/utils/context';
import { app } from '../../actions';
import { Button } from '../button/Button';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { useTheme } from '../../theme';

const Dialog = ({
	isOpen,
	onClose,
	close,
	closeStyle = {},
	component,
	children,

	noPadding,
	shouldShowCloseIcon = true,
	shouldShowOkButton = false,
	enableCloseDialog = true,
}) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	const closeDialog = () => {
		setOpen(false);
		close();
		if (onClose) {
			setTimeout(onClose, 300);
		}
	};

	const Component = component;

	return (
		<Modal
			animationIn="fadeIn"
			animationOut="fadeOut"
			backdropTransitionOutTiming={0}
			animationInTiming={10}
			animationOutTiming={10}
			onRequestClose={() => enableCloseDialog && closeDialog()}
			avoidKeyboard={true}
			// onSwipeComplete={closeDialog}
			// swipeDirection="down"
			onBackdropPress={() => enableCloseDialog && closeDialog()}
			isVisible={Boolean(open)}
		>
			<DialogContext.Provider
				value={{
					closeDialog,
				}}
			>
				<View style={[styles.dialogContainer, { padding: noPadding ? 0 : 20 }]}>
					{
						shouldShowCloseIcon && (
							<TouchableOpacity
								style={[styles.closeButton, closeStyle]}
								onPress={closeDialog}
								accessibilityRole="button"
								accessibilityLabel="Close"
							>
								<View style={styles.closeCircle}>
									<Feather name="x" size={18} color={colors.icon} />
								</View>
							</TouchableOpacity>
						)
					}
					{ Component && <Component closeDialog={closeDialog} /> }
					{ children && children }
					{
						shouldShowOkButton && (
							<View style={styles.okButtonContainer}>
								<Button
									label="Ok"
									onPress={closeDialog}
								/>
							</View>
						)
					}
				</View>
			</DialogContext.Provider>
		</Modal>
	);
};

const createStyles = ({ ui: { colors, radius } }) => ({
	dialogContainer: {
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
	},
	// 44 pt touch area around a 32 pt circle; chip colour stays visible on the surface in every theme.
	closeButton: {
		zIndex: 100,
		width: 44,
		height: 44,
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		top: 0,
		right: 0,
	},
	closeCircle: {
		width: 32,
		height: 32,
		borderRadius: radius.pill,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colors.chip,
	},
	okButtonContainer: {
		padding: 10,
		borderTopColor: colors.border,
		borderTopWidth: 1,
		borderBottomLeftRadius: radius.hero,
		borderBottomRightRadius: radius.hero,
		backgroundColor: colors.surface,
	},
});

const mapStateToProps = (state, ownProps) => ({
	isOpen: ownProps.isOpen !== undefined ? ownProps.isOpen : state.app.dialog.isOpen,
	component: ownProps.component ? ownProps.component : state.app.dialog.component,
});

const mapDispatchToProps = dispatch => ({
	close: () => dispatch(app.closeDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);
